import APIConfig from "service/network/APIConfig";
import APIService from "service/network/APIService";

/**
 * ICD-10 fuzzy search (api-icd-service). Backs the complaint search dropdown.
 *
 * Response is a plain array of { code, label, icdCode, managedRequired,
 * onMedicationRequired } — the CodeValuePair the CC v2 backend expects, minus
 * the fields we don't consume yet.
 *
 * Endpoint is on the services subdomain, NOT the api one — dev1.api.zyla.in
 * returns 404 on this path; services.dev1.zyla.in serves it.
 */
class IcdSearchService {
  constructor() {
    this.apiService = new APIService();
  }

  search(queryString, onResponse, onError) {
    const q = encodeURIComponent((queryString || "").trim());
    if (!q) {
      onResponse([]);
      return;
    }
    const url = APIConfig.icd.search.format(q);
    return this.apiService.get(url, onResponse, onError);
  }
}

export default IcdSearchService;
